import { Row, Column } from '@algbra/ui/components/Grid/Grid'
import Icon from '@algbra/ui/components/Icon/Icon'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import { getIconByName } from '@algbra/ui/icons'
import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import React, { useEffect, useState } from 'react'

import styles from './HomeBoxEthicalSavings.module.scss'
import { VAlign } from '@algbra/ui/enums/align'
import axios from 'axios'

export default function ZoneHomeBoxEthicalSavings() {
  const [topRate, setTopRate] = useState(null)

  const BoxDetailLink = props => {
    return (
      <Permalink className={styles.linkText} to={props.linkUrl}>
        <FreeText
          className={classNames(
            [styles.boxDetailLink, props.className],
            [styles[props.theme], props.theme]
          )}
          color={props.linkColor}
        >
          <div
            className={classNames(styles.icon, [
              styles[props.theme],
              props.theme,
            ])}
          >
            <Icon
              icon={getIconByName('arrow-right')}
              size={24}
              className={styles.arrow}
            />
          </div>
          <div className={styles.linkText}>{props.linkText}</div>
        </FreeText>
      </Permalink>
    )
  }

  useEffect(() => {
    axios
      .get('/.netlify/functions/topRate')
      .then(response => {
        setTopRate(response.data)
      })
      .catch(() => {
        setTopRate(null)
      })
  }, [])

  return (
    <Column size={12} sm={12} className={styles.column}>
      <div className={styles.ethicalSavingsContainer}>
        <Row vAlign={VAlign.CENTER} className={styles.bannerArea}>
          <Column size={12}>
            <Row>
              <Column sm={6}>
                <div className={styles.content}>
                  <StaticImage
                    src="../../images/early-access-home.png"
                    alt="Algbra Card"
                    layout="constrained"
                    width={106}
                    quality={100}
                    placeholder="blurred"
                    loading="eager"
                    className={styles.iconImage}
                  />
                  <Heading type="lg" className={styles.title} theme="dark">
                    Earn {topRate?.rate?.toFixed(2)}% EPR* <br />
                    with Ethical Saver Cubes
                  </Heading>
                  <FreeText className={styles.description} color="white">
                    Earn profit whilst helping to support sustainable
                    development globally.
                  </FreeText>
                  <BoxDetailLink
                    linkColor="white"
                    linkUrl="/features/ethical-savings/"
                    linkText="Find out more"
                    theme="white"
                  />
                </div>
              </Column>
            </Row>
          </Column>
        </Row>
        <div className={styles.disclaimerContainer}>
          <FreeText className={styles.disclaimer}>
            <strong>Available to UK residents only.</strong> Funds held in your
            Ethical Saver Cubes are protected by the FSCS up to £120,000. T&Cs
            apply.
          </FreeText>
          <StaticImage
            src="../../images/home/fscs-badge.png"
            alt="Algbra Card"
            layout="constrained"
            width={71}
            quality={100}
            placeholder="blurred"
            loading="eager"
            className={styles.logo}
          />
        </div>
      </div>
    </Column>
  )
}
